import { type FC } from "react";

import styled from "@emotion/styled";
import { Colors, Spacing } from "@snapchat/snap-design-system";

const ErrorMessage = styled.span`
    width: 100%;
    margin-top: ${Spacing.MD}px;
    padding-bottom: 8px;

    font-size: 12px;
    font-weight: 400;
    color: ${Colors.Red.V150};
`;

export const UpdatingErrorMessage: FC<{ message: string | null }> = ({ message }) => {
    if (!message) {
        return null;
    }

    return <ErrorMessage>{message}</ErrorMessage>;
};
